import { MenuItem } from "@mui/material";
import FormikSelect from "../../../commons/formik/FormikSelect";

const TipoContratista = ({ opcionesContratista, values, disabled }) => {
  const getFilteredOptions = () => {
    const resolution = values.resolucion;
    return opcionesContratista.filter((option) => {
      const nombre = option.nombre;
      if (resolution === "5197") {
        return nombre === "Contratista Principal" || nombre === "Subcontratista";
      }
      if (resolution === "3598") {
        return nombre === "Comitente" || nombre === "Contratista Principal";
      }
      if (resolution === "319/99") {
        return nombre === "Comitente" || nombre === "Contratista Principal" || nombre === "Subcontratista";
      }
      return true;
    });
  };

  return (
    <FormikSelect
      fullWidth
      name="idTipoContratista"
      label="Tipo de Contratista*"
      disabled={!values.resolucion || disabled}
    >
      {getFilteredOptions().map(({ id, nombre }) => {
        return (
          <MenuItem value={id} key={id}>
            {nombre}
          </MenuItem>
        );
      })}
    </FormikSelect>
  );
};

export default TipoContratista;
